<template>
  <div id="app_p" :style="$store.state.equipment.height" >
    <div class="header">
      <div class="main">
        <van-image round width="42px" height="42px" :src="currentUser.avatar" />
        <div class="desc">
          <div class="name"><span>{{ currentUser.realName }} </span>
            <div class="role">
              <div class="txt" style="font-size: 12px;">{{ currentUser.roleJs }}</div>
            </div>
          </div>
          <div clarr="org" >{{ currentUser.org }}</div>
        </div>
      </div>
      <span style="line-height:42px; margin-right:10px;color:#ADADAD" @click="logoutFlag=true">退出</span>
    </div>
    <div id="shouyeimage">
      <img width="100%" src="../assets/shouyeimage.png" />
    </div>
    <ul>

      <van-tabs :color='tabcolor' v-model="active">
        <van-tab v-for="(item, indexx) in nav" :key="indexx" :title="item.title">
          <div v-if="active == indexx && item.title == '通知'">
            <div v-if="sameHomeShowMes.length">
              <van-nav-bar left-text="消息通知" right-text="更多>" @click-right="onClickRight" />

              <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <template v-for="(obj, index) in sameHomeShowMes">
                  <ArticleItem v-if="index <= 2" :key="index" :article="obj" />
                </template>

              </van-list>
            </div>
            <div v-if="sameHomeShowAll.length">
              <van-nav-bar left-text="公共信息" @click-right="PublicClickRight">
                <template #right>
                  <div>
                    更多
                    <van-icon name="arrow" color="grey" size="16" />
                  </div>
                </template>
              </van-nav-bar>
              <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <template v-for="(obj, index) in sameHomeShowAll">
                  <ArticleItem v-if="index <= 2" :key="index" :article="obj" />
                </template>
              </van-list>
            </div>

            <div v-else class="other">
              <div class="other_1">

                <img src="../assets/other.png" alt="">
                <div>敬请期待</div>
              </div>


            </div>
          </div>
          <div v-if="active == indexx && item.title == '报考'">

            <div class="signup" @click="nameownclick">
              <van-cell is-link>
                <template #title>
                  <div class="left">
                    <img src="../assets/exam/ownbaokao.png" alt="">
                    <span class="title">自主报名</span>
                  </div>
                </template>
              </van-cell>
            </div>
            <van-divider :style="{ margin:'0', borderColor: '#E8E8E8', padding: '0 16px' }" />
                <div class="signup" @click="$router.push({ path: 'test_info' })">
                  <van-cell is-link>
                    <template #title>
                      <div class="left">
                        <img src="../assets/exam/baokaoinfo.png" alt="">
                        <span class="title">报考信息</span>
                      </div>
                    </template>
                  </van-cell>
                </div>
                <van-divider :style="{ margin:'0', borderColor: '#F5F5F5', padding: '0 16px' }" />

            <div class="signup" @click="userorder">
              <van-cell is-link>
                <template #title>
                  <div class="left">
                    <img src="../assets/exam/ownorder.png" alt="">
                    <span class="title">我的订单</span>
                  </div>
                </template>
              </van-cell>
            </div>
            <van-divider :style="{ margin:'0', borderColor: '#F5F5F5', padding: '0 16px' }" />
              </div>


          <template v-if="performance.length > 0 && active == indexx && item.title == '成绩'">
            <div class="certificate" v-for="(item, index) in performance" :key="index">
              <van-row class="marginrow" gutter="20">

                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    考生姓名：
                  </span>
                  <span>{{
                      item.userName
                  }}</span>
                </van-col>
              </van-row>
              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    {{item.scoreName}}成绩：
                  </span>
                  <span>{{
                      item.score
                  }}</span>
                </van-col>

              </van-row>
              

              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    批次名称：
                  </span>
                  <span>{{
                      item.bathName
                  }}</span>
                </van-col>

              </van-row>
              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    考试工种：
                  </span>
                  <span>{{
                      item.craftName
                  }}</span>
                </van-col>
              </van-row>

              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    等       级：
                  </span>
                  <span>{{
                      item.levelName
                  }}</span>
                </van-col>
              </van-row>
              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    准考证号：
                  </span>
                  <span>{{
                      item.examDocket
                  }}</span>
                </van-col>

              </van-row>


              <!-- <div class="row_footer"> -->
              <van-row class="checkinfotime">
                <span>考试日期:&nbsp;&nbsp;</span>
                <span>{{item.examDay}}</span>
              </van-row>
            </div>



          </template>
          <van-empty style="height: 54vh" v-if="performance.length == 0 && active == indexx && item.title == '成绩'"
            description="您还没有相关的成绩" />

          <van-empty style="height: 54vh" v-if="certificate.length == 0 && active == indexx && item.title == '证书'"
            description="您还没有相关的证书" />
          <template v-if="active == indexx && item.title == '证书' && certificate.length > 0">
            <div class="certificate" v-for="(item, index) in certificate" :key="index">
              <van-row class="marginrow" gutter="20">

                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    姓&nbsp;      名：
                  </span>
                  <span>{{
                      item.userName
                  }}</span>
                </van-col>
              </van-row>
              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    手 机 号：
                  </span>
                  <span>{{item.mobilePhone}}</span>
                </van-col>

              </van-row>
              <van-row class="marginrow" gutter="20">
               <van-col>
                    <span class="leftcolor" style="margin-right: 25px">
                      批次名称：
                    </span>
                    <span>{{
                        item.batchName 
                    }}</span>
                  </van-col>

              </van-row>

              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    考试工种：
                  </span>
                  <span>{{
                      item.craftName
                  }}</span>
                </van-col>
              </van-row>
              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    考试等级：
                  </span>
                  <span>{{
                      item.levelName
                  }}</span>
                </van-col>

              </van-row>

              <van-row class="marginrow" gutter="20">
                <van-col v-if="item.subjectScore['理论']!=null">
                  <span class="leftcolor" style="margin-right: 25px">
                    理论成绩：
                  </span>
                  <span>{{
                      item.subjectScore['理论']
                  }}</span>
                </van-col>

              </van-row>
              <van-row class="marginrow" gutter="20">
                <van-col v-if="item.subjectScore['实操']!=null">
                  <span class="leftcolor" style="margin-right: 25px">
                    实操成绩：
                  </span>
                  <span>{{
                      item.subjectScore['实操']
                  }}</span>
                </van-col>

              </van-row>
              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    证书状态：
                  </span>
                  <span v-if="item.certificateStatus == 'pending'">待生成</span>
                  <span v-if="item.certificateStatus == ''">不合格</span>
                  <span v-if="item.certificateStatus == 'finish'">已生成</span>
                </van-col>
              </van-row>

              <van-row class="marginrow" gutter="20">
                <van-col>
                  <span class="leftcolor" style="margin-right: 25px">
                    考试时间：
                  </span>
                  <span>{{
                      item.examDay
                  }}</span>
                </van-col>
              </van-row>

              <!-- <van-row class="checkinfo">
                    <van-button>查看证书</van-button>
                  </van-row> -->

              <van-row class="checkinfo"><span @click="selectzs(item.batchId)"
                  v-if="item.certificateStatus == 'finish'">查看证书</span></van-row>

            </div>
          </template>

          <!-- 机构页面相关  -->
          <div v-if="active == indexx && item.title == '机构服务'">
            <div v-if="currentUser.roleJs === '机构管理员'">
              <div class="zizhu" @click="upload">
                <img src="../assets/system/mingdan.png" alt="">
                <span class="zizhu_medi">上传名单</span>
                <van-icon class="zizhu_right" name="arrow" />
              </div>
              <div class="zizhu" @click="testmore">
                <img src="../assets/system/pbaokao.png" alt="">
                <span class="zizhu_medi">批量约考</span>
                <van-icon class="zizhu_right" name="arrow" />
              </div>
              <div class="zizhu" @click="myorder">
                <img src="../assets/system/order.png" alt="">
                <span class="zizhu_medi">我的订单</span>
                <van-icon class="zizhu_right" name="arrow" />
              </div>
              <div class="zizhu" @click="dynamicmore">
                <img src="../assets/system/exam.png" alt="">
                <span class="zizhu_medi">考试动态</span>
                <van-icon class="zizhu_right" name="arrow" />
              </div>
              <div class="zizhu" @click="resultmore">
                <img src="../assets/system/zhengshu.png" alt="">
                <span class="zizhu_medi">成绩证书</span>
                <van-icon class="zizhu_right" name="arrow" />
              </div>
            </div>

          </div>

          <!-- 协会页面相关  -->
          <div v-if="active == indexx && item.title == '评价服务'">
            <div class="other_1">
              <div class="zizhu" @click="namesign" v-if="currentUser.roleJs === '评价方管理员'">
                <img src="../assets/shenhe.png" alt="">
                <span class="zizhu_medi">报名审核</span>
                <van-icon class="zizhu_right" name="arrow" />
              </div>
              <div class="zizhu" @click="examList" v-if="currentUser.roleJs === '评价方管理员'">
                <img src="@/assets/image/association/exam_list.png" alt="">
                <span class="zizhu_medi">考试名单</span>
                <van-icon class="zizhu_right" name="arrow" />
              </div>
              <div class="zizhu" @click="examRoomPlan" v-if="currentUser.roleJs === '评价方管理员'">
                <img src="@/assets/image/association/plan.png" alt="">
                <span class="zizhu_medi">考场安排</span>
                <van-icon class="zizhu_right" name="arrow" />
              </div>
              <div class="zizhu" @click="userManage" v-if="currentUser.roleJs === '评价方管理员'">
                <img src="@/assets/image/association/user_manage.png" alt="">
                <span class="zizhu_medi">用户管理</span>
                <van-icon class="zizhu_right" name="arrow" />
              </div>
            </div>
          </div>
          <div v-if="active == indexx && item.title == '其他'">
            <div class="other">
              <div class="other_1">

                <img src="../assets/other.png" alt="">
                <div>敬请期待</div>
              </div>


            </div>
          </div>
        </van-tab>
      </van-tabs>
    </ul>
    <el-dialog
        :visible.sync="logoutFlag"
        width="266px"
        top="35vh"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
        class="logout"
      >
        <div slot="title" class="header-title">
           <span>提示</span>
        </div>
        <span>是否退出登录？</span>
        <div slot="footer" class="dialog-footer">
          <el-button  @click="logoutFlag=false">取 消</el-button>
          <el-button style="color:#54B0FB" @click="logout">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import headerBox from "@/components/header.vue";
import ArticleItem from "@/components/article-item/index.vue";
import {
  ShowExamsub,
  ShowScore,
} from "../api/apitotal.js";
// import {$eventbus} from '../../utils/eventbus.js'
export default {
  name: "app_p",
  components: {
    ArticleItem,
    headerBox,
  },

  filters: {
    nameFormat(value) {
      // if (value.length < 3) { //如果是两个汉字
      //   value = value.slice(0, 1) + '　　' + value.slice(1) //拆分字符串并加入全角的空格
      // } else if (value.length === 3) {
      //   value = value.slice(0, 1) + '　' + value.slice(1) //拆分字符串并加入全角的空格
      // }
      return "　　" + value;
    },
  },
  data() {
    return {
      // ,'机构管理员','协会管理员']
      tabcolor: "#54B0FB",
      //   isSelect: '使用',
      nav:[ ],
      // nav1:[ { title: "通知", rolelogin: "通知" },
      //   { title: "报考", rolelogin: "考生" },
      //   { title: "成绩", rolelogin: "成绩" },
      //   { title: "证书", rolelogin: "证书" },
      //   { title: "评价服务", rolelogin: "评价服务" },
      //   { title: "机构服务", rolelogin: "机构管理员" },
      //   { title: "其他", rolelogin: "其他" },],
      nav1:[
        { title: "通知", rolelogin: "通知" },
        { title: "报考", rolelogin: "考生" },
        { title: "成绩", rolelogin: "成绩" },
        { title: "证书", rolelogin: "证书" },
        { title: "其他", rolelogin: "其他" },
      ],
      nav2:[ 
        { title: "通知", rolelogin: "通知" },
        { title: "机构服务", rolelogin: "机构管理员" },
        { title: "其他", rolelogin: "其他" },
      ],
      nav3:[
        { title: "通知", rolelogin: "通知" },
        { title: "评价服务", rolelogin: "评价服务" },
        { title: "其他", rolelogin: "其他" },
      ],
      performance: [],
      certificate: [],
      sameHomeShowMes: [],
      sameHomeShowAll: [],
      // Score: window.sessionStorage.getItem("Score"),
      active: 0,
      list: [1, 2, 3],
      loading: false,
      finished: false,
      logoutFlag:false
    };
    
  },
  computed: {
    currentUser: function () {
      return this.$store.state.session.user;
    }
  },
  watch: {
    currentUser: function (value) {
      this.nav = this.nav1.filter((item) => {
        if (value.roleJs == "考生") {
          this.$nextTick(function(){
            this.nav = this.nav1})
         return item.title!="机构服务";
        } else if (value.roleJs == "机构管理员") {
          this.$nextTick(function(){
            this.nav = this.nav2
          })
          return item.title;
        }else if (value.roleJs == "评价方管理员") {
          this.$nextTick(function(){
          this.nav = this.nav3
          })
          return item.title;
        }
      });
    }
  },
  created() {
    this.message();
    this.fetchUserInfo();
    this.selectScore();
  },
  methods: {
    fetchUserInfo: function () {
      this.$http.post('/auth/base/info').then(res => {
        if (res.data.success) {
          this.$store.commit('session/updateUser', res.data.data)
          if (!res.data.data.mobilePhone) {
            this.$router.replace('/phone')
          }
        }
      })
    },
    selectzs(id) {
      const params={
        batchId:id
      }
      console.log(id)
      this.$http.get("ExamSocer/getCertificateUrl",{params}).then(
        (res) => {
          console.log(res.data);
          if (res.status == 200) {
            window.location.href="https://res.qxueyou.com/"+res.data.data.url
            // this.$router.push({ path: '/certificate',query:{img:res.data.data}})
          }
        }
      );
    },
    selectScore() {
      this.$http.get('ExamScore/findScore').then(
        (res) => {
          console.log(res.data.data.examScore)
          this.performance = res.data.data.examScore;
        }
      );
      this.$http.post('ExamScore/findCertificate').then(
        (res) => {
          console.log(res.data.data.examCertificate)
          this.certificate = res.data.data.examCertificate;
        }
      );
    },
    nameownclick() {
      const params = {
        occopationid: null,
      }
            this.$http.get("ExamAddress/FindListOccupation", params).then((res) => {
            if (res.status == 200) {
                if (res.data.length == 0) {
                    this.$message({
                    message: "暂无报考信息",
                    type: "warning",
                    });
                } else {
                       this.$router.push({ 
                        path: "/reserve",
                      
                      });
                      }
                        } 
      });
    },
    
    userorder() {
      this.$router.push("/order_form");
    },
    onLoad() {
      setTimeout(() => {
        if (this.list.length >= 3) {
          this.finished = true;
        }
      }, 1000);
    },
    namesign() {
      this.$router.push("/associationAudit");
    },
    examList() {
      this.$router.push("/examList")
    },
    userManage(){
      this.$router.push('/userManage')
    },
    examRoomPlan() {
      this.$router.push("/examRoomPlan")
    },
    
    //机构页面相关
    upload() { //上传名单
      this.$router.push("/uploadList");
    },
    testmore() {  //批量约考
      this.$router.push("/batchSignUp");
    },
    myorder() { // 我的订单
      this.$router.push("/order/list");
    },
    dynamicmore() {
      this.$router.push("/exam/dynamic");
    },
    resultmore() {
      this.$router.push("/grade");
    },
    

    
    onClickRight() {
      this.$router.push({ path: "/word" });
    },
    PublicClickRight() {
      this.$router.push({ path: "/message" });
    },
    message() {
      var sameshare = window.localStorage.getItem("phone") || null;
      const params = {
        Phone: sameshare,
      };
      this.$http.get('homeNews/homeShowAllNr', params).then(res => {
        this.sameHomeShowAll = res.data.data.list;
      });

      //           this.$http.post('score/queryl').then(res=>{
      //  console.log(res)
      //   if(res.data.success&res.status=='200'){

      //   }

      // })

      //       this.$http.post('score/getCertificateUrl').then(res=>{
      //  console.log(res)
      //   if(res.data.success&res.status=='200'){

      //   }

      // })
    },
    logout:function(){
      this.logoutFlag=false
      
      this.$http.delete('/auth/logout').then(res=>{
        if(res.data.success){
          // this.$store.commit('session/logout')
          this.$store.commit('session/updateUser', {})
          localStorage.removeItem("card");
          localStorage.removeItem("userId");
          localStorage.removeItem("phone");
          localStorage.removeItem("Score");
          localStorage.removeItem("tokenn");
          this.$router.replace({path:'/phones'})
        }
      }) 
    }
  },
};
</script>

<style lang='less' scoped>
.header {
  display: flex;
  justify-content: space-between;
  padding: 8px;

  .main {
    display: flex;

    .desc {
      display: flex;
      flex-direction: column;
      padding: 2px 16px;
      justify-content: center;

      .name {
        display: flex;
        flex-direction: row;
        font-weight: bold;
      }

      .org {
        color: #666;
        font-size: 12px;
      }
    }
  }

  .role {
    margin-left: 10px;
    display: flex;
    align-items: center;

    .txt {
      border: 1px solid #1989fa;
      color: #1989fa;
      padding: 4px 16px;
      border-radius: 40px;
    }
  }
  
   
}
 
#app_p {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #2c3e50;
  // font-size: 30px;
  background: #FFFFFF;
  width: 100%;
  height: 100vh;
}

.shouyeimage {
  img {
    height: 422px;
  }
}

#top {
  text-align: center;
  height: 176px;
  box-sizing: border-box;
  padding-top: 125px;
  background-color: #f7f7f7;
  padding-bottom: 69px;
}

.rightcha {
  float: left;
}

.rightcha img {
  vertical-align: middle;
}

.leftcolor {
  color: @graycolor;
}

#app_p>ul {
  background: @backgroundcolor;
}

.checkinfo {
  width: 100%;
  border-top: @allboxborder;
  padding: 20px 30px;
  box-sizing: border-box;
  background: @whitee;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-radius: 0 0 @circlemin @circlemin;
  margin-top: 32px;
}

.checkinfotime {
  width: 100%;
  border-top: @allboxborder;
  padding: 20px 30px;
  box-sizing: border-box;
  background: @whitee;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 0 0 @circlemin @circlemin;
  margin-top: 32px;
  color: @graycolor;
}

.checkinfo>span {
  display: inline-block;
  width: 156px;
  height: 64px;
  line-height: 64px;

  background: @bluebtn;
  color: @whitee;
  border-radius: @circlemin;
  text-align: center;
}

// .centerwz {
//   /* display: block; */
//   padding: 0px;
//   font-size: 30px;
//   line-height: 30px;
// }

// .active {
//   font-size: 28px;
// }
.marginrow {
  margin: 20px 0 0 32px;
}

::v-deep .van-nav-bar__text {
  color: black;
}

::v-deep .van-nav-bar__left .van-nav-bar__text {
  font-size: 35px;
}

.conent_box {
  padding-top: 10px;
  margin-top: 20px;
  box-sizing: border-box;
  width: 95%;
  height: 350px;
  background-color: #fff;
  border-radius: 10px;
  margin: 0 auto;
}

.conent_box2 {
  padding-top: 10px;
  width: 95%;
  height: 350px;
  background-color: #fff;
  border-radius: @circle;
  margin: 0 auto;
  margin-top: 20px;
  box-sizing: border-box;
}

.certificate {
  padding-top: 10px;
  width: 95%;
  // height: 696px;
  background-color: #fff;
  border-radius: @circle;
  // margin: 0 auto;
  margin: 20px auto;
  box-sizing: border-box;
}

.red {
  color: red;
  // font-weight: 700;
}

.row_footer {
  width: 100%;
  border-top: @allboxborder;
  padding: 18px @padingbox;
  background: @whitee;
  box-sizing: border-box;
  text-align: center;
}

::v-deep .van-tab__pane {
  overflow: hidden;
}

::v-deep .van-tabs__wrap {
  border-bottom: @allboxbordermin;
  height: 88px;
  line-height: 88px;
}

.zizhu {
  height: 110px;
  line-height: 110px;
  position: relative;
  padding: 20px 40px;
  border-bottom: @allboxbordermin;
  display: flex;
  align-items: center;
  background: @whitee;

  img {
    width: 82px;
    height: 82px;
  }

  .zizhu_medi {
    padding-left: @padingbox;
  }

  .zizhu_right {
    position: absolute;
    right: 40px;
    color: @rightjitou;
  }
}

// .row_footer div {
  // margin-top: 10px;
  // margin-left: 30px;
  // color: rgb(162, 159, 163);
// }

// .weight {
  // color: black;
  // font-weight: 600;
// }

.other {
  position: relative;
  height: 800px;

  .other_1 {
    position: absolute;
    top: 353px;
    left: 303px;

    img {
      width: 144px;
    }

    div {
      color: @indexcolor;
    }
  }
}

.em {
  letter-spacing: 0.33em;
}

.signup {
  display: flex;
  justify-content: center;
  align-items: center;
  

  .left {
    display: flex;
    align-items: center;
  }

  .van-cell {
    display: flex;
    align-items: center;
  }

  .title {
    margin-left: 36px;
  }
}

.logout .header-title{
    font-size: 34px;
    font-weight:bold;
    text-align: center; 
}
::v-deep .logout .el-dialog__body {
  padding: 10px 30px 0 30px;
  font-size: 16px;
  text-align: center;
  color: #666666;
}
::v-deep .logout .el-dialog__footer{
  width: 100%;
  padding: 0;
  margin-top:30px;
  border-top: 2px solid #EDEDED;
    
}
.logout .dialog-footer{
  width: 100%;
  display:flex;
  height: 90px;
}

.dialog-footer /deep/ .el-button{
  margin: 0;
  padding: 0;
  width: 100%;
  border-radius: 0;
  border: none;
  border-right: 2px solid #EDEDED;
  font-size: 16px;
}
</style>
